import React, { useState } from "react";
import { useDropzone } from "react-dropzone";

const DropzoneThumbnail = ({
  title,
  onFileUpload,
  accept = {
    "image/*": [],
    "audio/*": [],
    "video/*": [],
  },
}) => {
  const [filePreview, setFilePreview] = useState(null);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    accept: accept,
    maxFiles: 1,
    onDrop: (acceptedFiles) => {
      const previewFiles = acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: file.type.startsWith("image")
            ? URL.createObjectURL(file)
            : file.name,
        })
      );
      setFilePreview(previewFiles);

      // Pass the file URL to the parent component
      onFileUpload(previewFiles[0]);
    },
  });

  let dropzoneClass = "dropzone";
  if (isDragActive) dropzoneClass += " dropzone-active";
  if (isDragAccept) dropzoneClass += " dropzone-accept";
  if (isDragReject) dropzoneClass += " dropzone-reject";

  const handleDelete = () => {
    if (filePreview[0].type.startsWith("image")) {
      URL.revokeObjectURL(filePreview[0].preview);
    }
    setFilePreview(null);
    onFileUpload(null);
  };

  const thumbs = filePreview ? (
    <div className="file-preview">
      {filePreview[0].type.startsWith("image") ? (
        <div className="bg-thumbnailImage">
          <img
            src={filePreview[0].preview}
            alt={filePreview[0].name}
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              borderRadius: "15px",
              width: "100px",
            }}
          />
        </div>
      ) : (
        <div className="bg-thumbnailAudio">
          <p>{filePreview[0].name}</p>
        </div>
      )}
      <button
        className={`delete-btn ${
          filePreview[0].type.startsWith("image")
            ? "thumbnailImage"
            : "addAudio"
        }`}
        onClick={handleDelete}
      >
        &#x2715;
      </button>
    </div>
  ) : null;

  return (
    <>
      <div>
        <div {...getRootProps({ className: dropzoneClass })}>
          <input {...getInputProps()} />
          {filePreview ? null : (
            <div className="p-2">{`Drop or select ${title} here...`}</div>
          )}
          {thumbs}
        </div>
      </div>
    </>
  );
};

export default DropzoneThumbnail;
